var _rect, _rect2, _rect3, _path, _path2, _rect4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgReKey = function SvgReKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 4,
    fill: "#FFF9DC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 22,
    width: 42,
    height: 76,
    rx: 6,
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 64,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 75a2 2 0 00-2 2v3.416A5.001 5.001 0 0060 90a5 5 0 002-9.584V77a2 2 0 00-2-2z",
    fill: "#F8F8FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 80.416l.4.916.6-.262v-.654h-1zm4 0h-1v.654l.6.262.4-.916zM59 77a1 1 0 011-1v-2a3 3 0 00-3 3h2zm0 3.416V77h-2v3.416h2zM56 85c0-1.639.986-3.05 2.4-3.668l-.8-1.832A6.001 6.001 0 0054 85h2zm4 4a4 4 0 01-4-4h-2a6 6 0 006 6v-2zm4-4a4 4 0 01-4 4v2a6 6 0 006-6h-2zm-2.4-3.668A4.001 4.001 0 0164 85h2a6.001 6.001 0 00-3.6-5.5l-.8 1.832zM61 77v3.416h2V77h-2zm-1-1a1 1 0 011 1h2a3 3 0 00-3-3v2z",
    fill: "#332C4A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 32,
    width: 12,
    height: 54,
    rx: 6,
    transform: "rotate(90 108 32)",
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.005 69.959l2.765 1.647 2.358 4.083-1.67 3.11 6.43 11.134 7.052-4.071L20.074 56.65l-4.865-.141-.822 3.718 2.765 1.648 2.766 1.647.043 3.218.044 3.219z",
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.142 98.694c5.5-3.176 7.385-10.209 4.21-15.71-3.176-5.5-10.21-7.384-15.71-4.209-5.5 3.176-7.385 10.21-4.21 15.71 3.176 5.5 10.21 7.385 15.71 4.209zm-2.611-3.795a2.5 2.5 0 10-2.5-4.33 2.5 2.5 0 002.5 4.33z",
    fill: "#DFDFE9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.485 83.485c2.9 5.022 1.179 11.444-3.843 14.343l1 1.732c5.979-3.452 8.027-11.097 4.575-17.075l-1.732 1zM29.142 79.64c5.022-2.9 11.444-1.178 14.343 3.844l1.732-1c-3.451-5.979-11.096-8.027-17.075-4.576l1 1.732zm-3.843 14.344c-2.9-5.022-1.18-11.444 3.843-14.344l-1-1.732c-5.979 3.452-8.027 11.097-4.575 17.076l1.732-1zm14.343 3.843c-5.022 2.899-11.444 1.179-14.343-3.843l-1.732 1c3.451 5.978 11.096 8.027 17.075 4.575l-1-1.732zm-2.062-5.844a1.5 1.5 0 01-.55 2.049l1 1.732a3.5 3.5 0 001.282-4.781l-1.732 1zm-2.05-.55a1.5 1.5 0 012.05.55l1.732-1a3.5 3.5 0 00-4.781-1.281l1 1.732zm-.548 2.05a1.5 1.5 0 01.549-2.05l-1-1.731a3.5 3.5 0 00-1.281 4.78l1.732-1zm2.049.549a1.5 1.5 0 01-2.05-.55l-1.731 1a3.5 3.5 0 004.78 1.282l-1-1.732z",
    fill: "#332C4A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.08 87.311a5.5 5.5 0 016.736-3.889",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.037 66.07l1.571 2.809v4.715l-3 1.858v12.857h8.143V54.58l-4.143-2.555-2.571 2.809 1.571 2.81v2.808l-1.571 2.81v2.809z",
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.108 101.024c6.351 0 11.5-5.149 11.5-11.5 0-6.352-5.149-11.5-11.5-11.5s-11.5 5.148-11.5 11.5c0 6.351 5.149 11.5 11.5 11.5zm0-5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
    fill: "#FFD400"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.608 89.524c0 5.799-4.7 10.5-10.5 10.5v2c6.904 0 12.5-5.597 12.5-12.5h-2zm-10.5-10.5c5.8 0 10.5 4.7 10.5 10.5h2c0-6.904-5.596-12.5-12.5-12.5v2zm-10.5 10.5c0-5.8 4.701-10.5 10.5-10.5v-2c-6.903 0-12.5 5.596-12.5 12.5h2zm10.5 10.5c-5.799 0-10.5-4.701-10.5-10.5h-2c0 6.903 5.597 12.5 12.5 12.5v-2zm1.5-6.5a1.5 1.5 0 01-1.5 1.5v2a3.5 3.5 0 003.5-3.5h-2zm-1.5-1.5a1.5 1.5 0 011.5 1.5h2a3.5 3.5 0 00-3.5-3.5v2zm-1.5 1.5a1.5 1.5 0 011.5-1.5v-2a3.5 3.5 0 00-3.5 3.5h2zm1.5 1.5a1.5 1.5 0 01-1.5-1.5h-2a3.5 3.5 0 003.5 3.5v-2z",
    fill: "#332C4A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.997 85.635a5.5 5.5 0 00-7.778 0",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 44,
    width: 12,
    height: 12,
    rx: 6,
    transform: "rotate(-180 66 44)",
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 2
  })));
};

export default SvgReKey;